module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAALJJREFUeAHt2DEKwCAMBVDt/e/cOv8pCC2hvmyBCPqSxYwhCBAgQIAAAQIECBAgQIAAAQJnCczqc+8V1dqOdXNF5V5XpeikGiDRbSBAQiBSExIgUgIECBAgQIAAAQI9BUo7gp2rd9uf2IfsdHGd8bkLOCBAQiBSExIgUgIECBAgQIAAAQI9BV7bh1Sf+9XexD6k2pGo87kDEgKRmhAgISAlQIAAAQIECBAgQIAAAQK/F3gAgZEMImNlAH4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon-menu.png
// module id = QYMK
// module chunks = 0